import React from 'react';
import { EdgeProps, getSmoothStepPath } from 'reactflow';
import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ErrorEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 16,
  });

  return (
    <>
      <path
        id={id}
        style={{
          ...style,
          stroke: '#FF4C4C',
          strokeWidth: 1.5,
        }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />

      <foreignObject
        width={140}
        height={30}
        x={labelX - 70}
        y={labelY - 15}
        className="edge-error-badge"
      >
        <Box
          sx={{
            backgroundColor: '#FEF3F2',
            borderRadius: '4px',
            padding: '4px 8px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            border: '1px solid #FEE4E2',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
          }}
        >
          <ErrorOutlineIcon sx={{ color: '#F04438', fontSize: 14 }} />
          <Typography sx={{ fontSize: '12px', color: '#101828', fontWeight: 500 }}>
            Error in the connection
          </Typography>
        </Box>
      </foreignObject>
    </>
  );
};

export default ErrorEdge;
